export default {
  HOSPITALLIST: "hospitalList.html",
  RECORDEVEN:"reportDates.html",
  GETWXAPI:"shareApi.html",
  GETQRCODR:"getErImg.html",
};
